import { window } from "global";
import React, { useState, useEffect, useMemo, useCallback, useRef } from "react";
import classnames from "classnames";
import MediaQuery from "components/MediaQuery";
import MatchSummary from "./MatchSummary";
import ExpandedMatchCard from "./ExpandedMatchCard";
import { NotificationManager } from "react-notifications";

import ArenaMatchSummary from "@ugg/shared/components/SummonerProfiles/match-card/ArenaMatchSummary";
import ExpandedArenaMatchCard from "@ugg/shared/components/SummonerProfiles/match-card/ExpandedArenaMatchCard";
// import { useTraceUpdate } from "lib/hooks/testingHooks";

const LargeMatchCard = (props) => {
  const [hovered, setHovered] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const { data, isGold, matchLP, isNew, observable } = props;

  const observerNode = useRef();
  const observer = useRef();
  const [showMatchCard, setShowMatchCard] = useState(!observable);

  useEffect(() => {
    if (showMatchCard && observer.current) {
      return observer.current.disconnect();
    }

    observer.current = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShowMatchCard(true);
        }
      },
      {
        rootMargin: "200px 0px 200px 0px",
        threshold: 0,
      },
    );

    if (observerNode.current) {
      observer.current.observe(observerNode.current);
    }

    return () => observer.current.disconnect();
  }, [showMatchCard]);

  if (!data) {
    return null;
  }

  let { win, matchDuration, version, summonerName, regionId, matchId, teamA, teamB } = data;

  const isBadPerfScore = useMemo(() => {
    let isBadData = false;
    for (const team of [teamA, teamB]) {
      let count = 0;
      team.forEach((player) => {
        const avgScore = Math.round(((player.hardCarry || 0) + (player.teamplay || 0)) / 2);
        if (avgScore > 120) {
          count++;
        }
      });

      if (count >= 2) {
        isBadData = true;
      }
    }
    return isBadData;
  }, [data]);

  const remake = matchDuration <= 270;
  const winConditionClass = `match_${isGold ? "gold" : remake ? "remake" : win ? "win" : "lose"}`;

  if (window && !showMatchCard) {
    return (
      <div className={`large-match-card-container ${winConditionClass}`} ref={observerNode}>
        <MediaQuery min="MOBILE_SMALL" max="MOBILE_MEDIUM">
          <div className={`match-summary_mobile ${winConditionClass}`} />
        </MediaQuery>
        <MediaQuery min="MOBILE_LARGE" max="DESKTOP_LARGE">
          <div className={`match-summary_desktop ${winConditionClass}`} />
        </MediaQuery>
      </div>
    );
  }

  const matchCardClassNames = classnames("large-match-card-container", winConditionClass, {
    "is-expanded": isExpanded,
    "is-hovered": hovered,
  });

  return data.queueType === "arena" ? (
    <div className={matchCardClassNames} onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}>
      <ArenaMatchSummary
        data={data}
        isNew={isNew}
        matchLP={matchLP}
        winConditionClass={winConditionClass}
        isExpanded={isExpanded}
        setIsExpanded={setIsExpanded}
      />
      {isExpanded && <ExpandedArenaMatchCard data={data} />}
    </div>
  ) : (
    <div className={matchCardClassNames} onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}>
      <MatchSummary
        data={data}
        isGold={isGold}
        isNew={isNew}
        matchLP={matchLP}
        winConditionClass={winConditionClass}
        isExpanded={isExpanded}
        setIsExpanded={setIsExpanded}
        isBadPerfScore={isBadPerfScore}
      />
      {isExpanded && (
        <ExpandedMatchCard
          summonerName={summonerName}
          regionId={regionId}
          matchId={matchId}
          version={version}
          isBadPerfScore={isBadPerfScore}
          winConditionClass={winConditionClass}
        />
      )}
    </div>
  );
};

export default LargeMatchCard;

// LargeMatchCard.whyDidYouRender = true;
